import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import GlobalSection from '../../components/basics/global/GlobalSection';
import TariffListComposition from '../../components/compositions/tariff/TariffList';
import { getAllLabelCallouts } from '../../selectors/callout';
import * as cartActions from '../../actions/order/cart';
import { addItem, removeItem } from '../../actions/order/process';
import { createNormalizeTargetEntitiesSelector } from '../../selectors/entity';
import { fetchEntitiesByIds } from '../../actions/request/registry';
import { areObjectsEqual } from '../../helpers/objectEquals';

class TariffList extends PureComponent {

  componentDidMount() {
    const { fetchTariffOptions, optionIds } = this.props;
    fetchTariffOptions(optionIds);
  }

  render() {
    const {
      moduleId,
      params,
      layoutSettings,
      tariffs,
      labelCallouts,
      primaryModule,
      onSubmit,
      shoppingCartRoute,
      tariffOptions,
      addOrderItem,
      removeOrderItem,
      orderProcess,
      zweitkarte,
      isReady,
    } = this.props;

    return (
      <GlobalSection
        layout="contained"
        theme={params.colorScheme}
        layoutSettings={layoutSettings}
      >
        <TariffListComposition
          moduleId={moduleId}
          theme={params.style}
          layout={params.layout}
          primaryModule={primaryModule}
          tariffsHeadline={params.header}
          tariffsCopy={params.footer}
          colorScheme={params.colorScheme}
          featureSet={params.featureSet}
          tariffs={tariffs}
          labelCallouts={labelCallouts}
          onSubmit={onSubmit}
          shoppingCartRoute={shoppingCartRoute}
          tariffOptions={tariffOptions}
          addItem={addOrderItem}
          removeItem={removeOrderItem}
          orderProcess={orderProcess}
          zweitkarte={zweitkarte}
          isReady={isReady}
        />
      </GlobalSection>
    );
  }
}

TariffList.propTypes = {
  moduleId: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
  layoutSettings: PropTypes.object,
  primaryModule: PropTypes.bool.isRequired,
  tariffs: PropTypes.array.isRequired,
  labelCallouts: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  shoppingCartRoute: PropTypes.object,
  fetchTariffOptions: PropTypes.func.isRequired,
  tariffOptions: PropTypes.array,
  optionIds: PropTypes.array,
  addOrderItem: PropTypes.func.isRequired,
  removeOrderItem: PropTypes.func.isRequired,
  orderProcess: PropTypes.object,
  zweitkarte: PropTypes.bool,
  isReady: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
  fetchTariffOptions: ids => dispatch(fetchEntitiesByIds(ids)),
  addOrderItem: (item, persistent) => dispatch(addItem(item, persistent)),
  removeOrderItem: (item, persistent) => dispatch(removeItem(item, persistent)),
  dispatch,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { url } = stateProps.shoppingCartRoute;
  const { dispatch } = dispatchProps;
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSubmit: async (items) => {
      // the items we get passed are not real entities, they were transformed any may not
      // contain all properties of the original entities. hence we need to fetch the real
      // entities again (or retrieve them from the store).
      const entities = await dispatch(fetchEntitiesByIds(items.map(item => item.eid)));
      dispatch(cartActions.replaceCart(entities));
      dispatch(push(url));
    },
  };
};

function makeStateToProps() {
  const normalizeTariffEntitySelector = createNormalizeTargetEntitiesSelector({ style: 'strike' });
  const normalizeOptionEntitySelector = createNormalizeTargetEntitiesSelector({ style: 'strike' });
  return (state, ownProps) => {
    const { orderProcess } = state;
    const { entities, behaviorSettings } = ownProps;
    const optionIds = [];
    entities.map(entity => entity.options
      .map(option => !optionIds.includes(option) && optionIds.push(option)));
    const tariffOptions = optionIds.map(id => state.entities.tariffOptionEntity[id]);
    return {
      labelCallouts: getAllLabelCallouts([...ownProps.entities, { eid: ownProps.moduleId }], state),
      shoppingCartRoute: state.site.sitemap.ShoppingCartRoute,
      tariffs: normalizeTariffEntitySelector(state, entities),
      tariffOptions: normalizeOptionEntitySelector(state, tariffOptions),
      orderProcess,
      optionIds,
      zweitkarte: behaviorSettings && behaviorSettings.zweitkarte,
      isReady: !state.lifecycle.isBlockingRequestInProgress,
    };
  };
}

const Container = connect(
  makeStateToProps,
  mapDispatchToProps,
  mergeProps,
  {
    areStatesEqual: (next, prev) => areObjectsEqual(next, prev, {
      entities: { tariffOptionEntity: {}, tariffs: {}, promotionVO: {} },
      lifecyle: { isBlockingRequestInProgress: {} },
      site: { routing: { requestedLocation: {} }, contractRenewal: {}, bookablePromotions: {} },
      callouts: {},
      user: {
        esimStatusResponse: {},
        contractData: { earlyContractRenewalFee: {} },
        bookablePromotions: {},
        selectedOptionalPromotions: {},
        grantedPromotions: {},
        grantedCampaignPromotions: {},
      },
      routing: {},
    }),
  },
)(TariffList);

export default Container;
